import React from 'react';
import { useParams } from 'react-router-dom';

import { BankAccountsTable } from '~/components/BankAccountsTable';

interface Params {
  id: string;
}

export const PageEntityAccounts: React.FC = () => {
  const { id } = useParams<keyof Params>() as Params;

  return <BankAccountsTable entityId={id} />;
};
